module.exports = __webpack_public_path__ + "static/sa-8f3e4e416935a439635ab7fceeefd641.svg";